import { Injectable, inject } from '@angular/core';
import { CanActivateFn, ActivatedRouteSnapshot, RouterStateSnapshot, Router, UrlSegmentGroup, Params } from '@angular/router';
// import { LocalStorageService } from './local-storage.service';
// import { Observable } from 'rxjs';
// import { LoginService } from '../services/login.service';
import { CookieService } from "ngx-cookie-service";

interface ParamMap {
  keys: string[]
  has(name: string): boolean
  get(name: string): string | null
  getAll(name: string): string[]
}
class UrlTree {
  constructor(
    root: UrlSegmentGroup = new UrlSegmentGroup([], {}),
    queryParams: Params = {},
    fragment: string = null
  ) { }
  root: UrlSegmentGroup
  queryParams: Params
  fragment: string | null
  queryParamMap: ParamMap
}

@Injectable({
  providedIn: 'root'
})
class UserToken {
  constructor(
    private cookieService: CookieService
  ) { }
  accessToken = this.cookieService.get("accessToken")
}

@Injectable({
  providedIn: 'root'
})
class PermissionsService {
  constructor(
    private router: Router,
    private cookieService: CookieService
  ) { }
  // canActivate(currentUser: UserToken, userId: string): boolean {
  //   return true;
  // }

  // canActivate(
  //   route: ActivatedRouteSnapshot,
  //   state: RouterStateSnapshot
  // ):
  //   | Observable<boolean | UrlTree>
  //   | Promise<boolean | UrlTree>
  //   | boolean
  //   | UrlTree {
  //   let validateInput = {
  // access_token: accessToken,
  // identity_token: idToken,
  //   };
  //   return this.loginService.ValidateLogin(validateInput)
  //     .then((res) => {
  //       if (res) {
  //         return true;
  //       } else {
  //         return this.router.createUrlTree(['/signin']);
  //       }
  //     })
  //     .catch(() => {
  //       return this.router.createUrlTree(['/signin']);
  //     });
  // }

  canMatch(currentUser: UserToken): boolean | UrlTree {
    if (this.cookieService.get("accessToken")) {
      return true;
    } else {
      return this.router.parseUrl('/signin');
    }
  }
}

export const canActivateTeam: CanActivateFn =
  (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
    return inject(PermissionsService).canMatch(inject(UserToken));
    // return inject(PermissionService).canActivate(route, state);
  };